<template>
  <div class="settings-rest">
    <h5>General Settings</h5>    
    <div class="row">
      <div class="col-12" v-if="configItemsOrdered.length">
        <div v-for="(configItem, index) in configItemsOrdered" :key="index" class="form-group">  
          <label
            :class="[
              { 'highlight' : activeHash === '#sidebar-logo' && configItem.key === 'generalSidebarLogo' },
              { 'highlight' : activeHash === '#sidebar-brand-logo' && configItem.key === 'generalSidebarBrandLogo' },
              { 'highlight' : activeHash === '#sidebar-header-colour' && configItem.key === 'generalSidebarHeaderColour' },
              { 'highlight' : activeHash === '#sidebar-description-colour' && configItem.key === 'generalSidebarDescriptionColour' },
            ]"
          >{{ configItem.label }}</label>
          <input-asset
            v-if="configItem.input.type === 'assetMulti' || configItem.input.type === 'asset'"
            :key="configItem._id"
            v-model="configItem.value"
            :multiple="configItem.input.type === 'assetMulti'"
            requirements="Supported formats: jpg, png, gif, mp4"
          />
          <ck-editor
            v-if="configItem.input.type === 'rich'"
            :key="configItem._id"
            v-model="configItem.value[activeLanguage.code]"
          />
          <input
            v-if="configItem.input.type === 'text'"
            :key="configItem._id"
            v-model="configItem.value[activeLanguage.code]"
            type="text"
            class="form-control"
          />
          <colour-picker
            v-if="configItem.input.type === 'colour'"
            :key="configItem._id"
            v-model="configItem.value"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <button @click="updateSettings" class="btn btn-primary">
          Update Settings
        </button>
      </div>
    </div>

    <!-- TODO: Add user access restriction -->
    <div v-if="false" class="row">
      <div class="col-12">
        <button @click="isNewSettingActive = !isNewSettingActive" class="btn btn-primary mb-4">
          {{ isNewSettingActive ? 'Close' : 'Add Setting' }}
        </button>
        <div v-if="isNewSettingActive">
          <div class="form-group">
            <label>Key</label>
            <input class="form-control" type="text" disabled v-model="addNewSettingKey">
          </div>
          <div class="form-group">
            <label>Setting Label</label>
            <input class="form-control" type="text" placeholder="Setting Label" v-model="addNewSetting.label">
          </div>
          <div class="form-group">
            <label>Setting Input Type</label>
            <select class="form-control" v-model="addNewSetting.input.type">
              <option value="asset">Asset</option>
              <option value="assetMulti">Multiple Assets</option>
              <option value="text">Text</option>
              <option value="rich">Rich Text</option>
              <option value="colour">Colour Picker</option>
            </select>
          </div>
          <button @click="addSetting" :disabled="!addNewSetting.label || !addNewSetting.input.type" class="btn btn-primary mb-4">
            Create Setting
          </button>
        </div>        
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { CONFIG_ITEM_CREATE, CONFIG_ITEMS_EDIT, FETCH_CONFIG_ITEMS } from '@/store/actions.type'
import store from '@/store'
import AssetPreviewBox from '@/components/AssetPreviewBox'
import CardTabs from '@/components/Cards/TabsCard'
import CkEditor from '@/components/CKEditor'
import ColourPicker from '@/components/ColourPicker'
import InputAsset from '@/components/InputAsset'
import _ from 'lodash'

export default {
  name: 'Settings',

  components: {
    AssetPreviewBox,
    CardTabs,
    CkEditor,
    ColourPicker,
    InputAsset
  },

  data() {
    return {
      addNewSetting: {
        key: null,
        input: {
          type: ''
        },
        label: '',
        value: null
      },
      generalConfigKeys: [
        'generalSidebarBrandLogo',
        'generalSidebarLogo',
        // 'generalSidebarHeaderColour',
        // 'generalSidebarDescriptionColour',
        'videoWallTrigger',
        'generalPackageBackground'
      ],
      isNewSettingActive: false
    }
  },

  computed: {
    ...mapGetters(['configItems', 'activeLanguage']),

    activeHash () {
      return this.$router.currentRoute.hash
    },

    addNewSettingKey () {
      return _.camelCase(`general${_.startCase(this.addNewSetting.label)}`)
    },

    addNewSettingValue () {
      switch (this.addNewSetting.input.type) {
        case 'text':
          return {
            en: ''
          }
          break;

        case 'rich':
          return {
            en: ''
          }
          break;

        case 'asset':
          return ''
          break;

        case 'assetMulti':
          return []
          break;
      
        default:
          return null
          break;
      }
    },

    configItemsOrdered() {
      let configItems = this.configItems.filter(item => {
        return this.generalConfigKeys.includes(item.key)
      })

      var orderedItems = _.sortBy(configItems, item => {
        return this.generalConfigKeys.indexOf(item.key)
      })

      return orderedItems
    }
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
  },

  async mounted() {
    this.$store.dispatch(FETCH_CONFIG_ITEMS)
      .then(res => {
        if (_.isEmpty(res)) {
          this.$notify({
            message: 'No config items found',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning'
          })
        }
      })
      .catch(err => [
        this.$notify({
          message: 'Error retrieving config items - ' + err,
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        })
      ])
  },

  methods: {
    addSetting () {
      this.addNewSetting.key = this.addNewSettingKey
      this.addNewSetting.value = this.addNewSettingValue

      this.$store.dispatch(CONFIG_ITEM_CREATE, this.addNewSetting)
    },

    updateSettings () {
      this.$store
        .dispatch(CONFIG_ITEMS_EDIT, this.configItems)
        .then(() => {
          this.$notify({
            message: 'Config items successfully updated',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          })
        })
        .catch(err => {
          this.$notify({
            message: 'Error updating config items - ' + err,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          })
        })
    }
  }
}
</script>
